
export const reports = {
	rawmaterial: "reports/rawmaterial-stock",
	factory: "reports/factory-stock",
	warehouse: "reports/warehouse-stock",
	retailer: "reports/retailer-stock",
	sales: "reports/sales",
	itemSales: "reports/item-sales",
	salesReturn: "reports/sales-return",
	purchase: "reports/purchase",
	itemPurchase: "reports/item-purchase",
	purchaseReturn: "reports/purchase-return",
	production: "reports/production",
	commission: "reports/commission",
}

export default {
	reports,
	login: "admin/login",
	forgotPassword: "/admin/forgot-password",
	resetPassword: "/admin/reset-password",
	updateProfile: "/profile",
	updatePassword: "/profile/password",
	addUser: "admin",
	updateUser: "admin/:id",
	viewUsers: "admin/page/:page/:perPage",
	resetUserPassword: "reset-password/:id",
	searchExecutives: "executives",
	searchShippingStaffs: "shipping-staffs",
	viewUserRoles: "adminrole",
	addUserRole: "adminrole",
	updateUserRole: "adminrole/:id",
	viewModules: "module",
	addModule: "module",
	updateModule: "module/:id",
	viewModuleAccesses: "moduleaccess/page/:page/:perPage",
	updateModuleAccess: "moduleaccess/:id",
	getCountries: "country",
	addCountry: "country",
	updateCountry: "country/:id",
	getStatesByCountry: "country/:country/state",
	getStates: "state/page/:page/:perPage",
	addState: "state",
	updateState: "state/:id",
	getDistrictsByState: "state/:state/district",
	getDistricts: "district/page/:page/:perPage",
	addDistrict: "district",
	updateDistrict: "district/:id",
	getCitiesByState: "state/:state/city",
	getCities: "city/page/:page/:perPage",
	addCity: "city",
	updateCity: "city/:id",
	getPanchayathsByDistrict: "district/:district/panchayath",
	getPanchayaths: "panchayath/page/:page/:perPage",
	addPanchayath: "panchayath",
	updatePanchayath: "panchayath/:id",
	getAgentsCount: "agent/count",
	getAgents: "agent/page/:page/:perPage",
	searchAgents: "agent",
	addAgent: "agent",
	updateAgent: "agent/:id",
	getCustomerTypes: "customertype",
	addCustomerType: "customertype",
	updateCustomerType: "customertype/:id",
	getItemCategories: "itemcategory",
	addItemCategory: "itemcategory",
	updateItemCategory: "itemcategory/:id",
	getUnits: "unit",
	addUnit: "unit",
	updateUnit: "unit/:id",
	getTaxes: "tax",
	addTax: "tax",
	updateTax: "tax/:id",
	getIdCardTypes: "idcardtype",
	getCustomersCount: "customer/count",
	getCustomers: "customer/page/:page/:perPage",
	searchCustomers: "customer",
	addCustomer: "customer",
	updateCustomer: "customer/:id",
	getItems: "item",
	searchItems: "search-item",
	addItem: "item",
	updateItem: "item/:id",
	getAllDistributors: "distributor",
	getDistributors: "distributor/page/:page/:perPage",
	addDistributor: "distributor",
	updateDistributor: "distributor/:id",
	getAllRetailers: "retailer",
	getRetailers: "retailer/page/:page/:perPage",
	searchRetailers: "search-retailer",
	addRetailer: "retailer",
	updateRetailer: "retailer/:id",
	getInvoices: "invoice/page/:page/:perPage",
	getInvoice: "invoice/:code",
	saveInvoice: "invoice",
	updateInvoice: "invoice/:id",
	confirmInvoice: "confirm-invoice/:id",
	approveInvoice: "approve-invoice/:id",
	cancelInvoice: "cancel-invoice/:id",
	shipInvoice: "ship-invoice/:id",
	deliverInvoice: "deliver-invoice/:id",
	getInvoicesCount: "invoice-count",
	getOrdersCount: "order-count",
	getSalesReturns: "sales-return/page/:page/:perPage",
	getSalesReturn: "sales-return/:id",
	saveSalesReturn: "sales-return",
	updateSalesReturn: "sales-return/:id",
	confirmSalesReturn: "confirm-sales-return/:id",
	approveSalesReturn: "approve-sales-return/:id",
	cancelSalesReturn: "cancel-sales-return/:id",
	viewBrandAccesses: "brandaccess/page/:page/:perPage",
	updateBrandAccess: "brandaccess/:id",
	getBrands: "brand",
	addBrand: "brand",
	updateBrand: "brand/:id",
	getExtraDiscounts: "extradiscount",
	addExtraDiscount: "extradiscount",
	updateExtraDiscount: "extradiscount/:id",
	getFactories: "factory/page/:page/:perPage",
	addFactory: "factory",
	updateFactory: "factory/:id",
	getWarehouses: "warehouse/page/:page/:perPage",
	addWarehouse: "warehouse",
	updateWarehouse: "warehouse/:id",
	getRawMaterials: "rawmaterial/page/:page/:perPage",
	searchRawMaterials: "rawmaterial",
	addRawMaterial: "rawmaterial",
	updateRawMaterial: "rawmaterial/:id",
	getPurchases: "purchase/page/:page/:perPage",
	getPurchase: "purchase/:id",
	savePurchase: "purchase",
	updatePurchase: "purchase/:id",
	approvePurchase: "approve-purchase/:id",
	cancelPurchase: "cancel-purchase/:id",
	getPurchaseReturns: "purchase-return/page/:page/:perPage",
	getPurchaseReturn: "purchase-return/:id",
	savePurchaseReturn: "purchase-return",
	updatePurchaseReturn: "purchase-return/:id",
	confirmPurchaseReturn: "confirm-purchase-return/:id",
	approvePurchaseReturn: "approve-purchase-return/:id",
	cancelPurchaseReturn: "cancel-purchase-return/:id",
	getProductions: "production/page/:page/:perPage",
	getProduction: "production/:id",
	saveProduction: "production",
	updateProduction: "production/:id",
	approveProduction: "approve-production/:id",
	cancelProduction: "cancel-production/:id",
	saveStockDispatch: "stock-dispatch",
	updateStockDispatch: "stock-dispatch/:id",
	getStockDispatches: "stock-dispatch/page/:page/:perPage",
	getStockDispatch: "stock-dispatch/:id",
	approveStockDispatch: "approve-stock-dispatch/:id",
	cancelStockDispatch: "cancel-stock-dispatch/:id",
	saveStockMovement: "stock-movement",
	updateStockMovement: "stock-movement/:id",
	getStockMovements: "stock-movement/page/:page/:perPage",
	getStockMovement: "stock-movement/:id",
	approveStockMovement: "approve-stock-movement/:id",
	cancelStockMovement: "cancel-stock-movement/:id",
	getInvoiceCommissions: "invoice-commission/page/:page/:perPage",
	updateCommission: "invoice-commission/:id",
	approveCommission: "approve-invoice-commission/:id",
}
